import { useLang } from 'hooks/lang';

import { FullTask } from 'entities';

import { Button } from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';

import { useSubTaskOwnerChange } from './changeOwner.hook';

interface SubTaskOwnerProps {
  children?: never;
  subTask: FullTask['subTasks'][number];
}

export function SubTaskOwner({ subTask }: SubTaskOwnerProps) {
  const { t } = useLang();

  const { canChangeOwner, handleChangeClick } = useSubTaskOwnerChange(subTask);

  return (
    <Button
      variant="ghost"
      onClick={canChangeOwner ? handleChangeClick : undefined}
      className="py-0.5 font-normal text-inherit disabled:opacity-100"
      disabled={!canChangeOwner}
      tooltipContent={t('change-owner')}
    >
      <UserAvatar user={subTask.owner} size={24} name />
    </Button>
  );
}
